import { VehicleValuationStatus } from "@/api-schema-enums";

export const canVehicleValuationBeStarted = (status: VehicleValuationStatus): boolean => {
  return VehicleValuationStatus.WaitingForConfirmation === status;
};
